import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './theme-context';
import { SessionProvider } from './session-context';
import { ToastProvider } from './@/components/ui/use-toast';
import DarkModeToggle from './dark-mode-toggle';
import JoinSession from 'session-management/join-session';
import SessionHeader from 'session-management/session-header';
import CampaignDashboard from 'campaign-dashboard';

function App() {
  return (
    <Router>
      <ThemeProvider>
        <ToastProvider>
          <SessionProvider>
            <div className="App p-4 dark:bg-gray-900 dark:text-white min-h-screen">
              <div className="flex justify-center items-center mb-4 relative">
                <h1 className="text-3xl font-bold text-center">Stormwrack Campaign Manager</h1>
                <div className="absolute right-0">
                  <DarkModeToggle />
                </div>
              </div>
              
              <SessionHeader />
              
              <Routes>
                <Route path="/" element={<JoinSession />} />
                <Route 
                  path="/session/:sessionId" 
                  element={<CampaignDashboard />} 
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </SessionProvider>
        </ToastProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;